// 系统管理路由

const sysRouter = {
  path: 'sys',
  name: 'sys',
  component: { render: h => h('router-view') },
  children: [
    {
      path: 'features',
      name: 'features',
      component: () =>
        import(/* webpackChunkName: 'sys' */ 'views/sys/features'),
    },
    {
      path: 'business',
      name: 'business',
      component: () =>
        import(/* webpackChunkName: 'sys' */ 'views/sys/business'),
    },
    {
      path: 'passwordReset',
      name: 'reset-password',
      component: () =>
        import(/* webpackChunkName: 'sys' */ 'views/sys/reset-password'),
    },
    {
      path: 'menu',
      name: 'menu',
      component: () => import(/* webpackChunkName: 'sys' */ 'views/sys/menu'),
    },
  ],
}

export default sysRouter
